import StarOutlineIcon from "@mui/icons-material/StarOutline";
import { ErrorBoundary } from "@sentry/react";
import React, { useMemo } from "react";
import { ToastContainer } from "react-toastify";
import { ErrorMsg } from "../../components/AppMessages";
import { DashboardCard } from "../../components/DashboardCard/DashboardCard";
import { CedarShellLayout } from "../../components/Layouts";
import { useFavouriteDashboards } from "../../hooks";
import { useDashboardRegistry } from "../../hooks/react-query/dashboards/useDashboardRegistry";
import "./favouritesPage.scss";

export const FavouritesPage = () => {
  const { dashboards } = useDashboardRegistry();
  const { favouriteIds } = useFavouriteDashboards();

  const favouriteDashboards = useMemo(
    // is_active now doubles as "archived" (dashboardsApi.ts's own getDashboardRegistry comment) -
    // a dashboard favourited before being archived no longer shows up here once it is, rather
    // than silently reappearing in an "active dashboards" list it no longer belongs in.
    () => dashboards.filter((dashboard) => dashboard.is_active && favouriteIds.includes(dashboard.key)),
    [dashboards, favouriteIds]
  );

  return (
    <CedarShellLayout>
      <ErrorBoundary fallback={<ErrorMsg class={"formError"} />}>
        <div className="favourites_page" data-test-id="favourites-page">
          <div className="favourites_page_header">
            <StarOutlineIcon className="page_header_icon" />
            <div>
              <h1 className="favourites_page_title">Favourite Dashboards</h1>
              <p className="favourites_page_subtitle">Your starred reports</p>
            </div>
          </div>

          {favouriteDashboards.length === 0 ? (
            <p className="favourites_page_empty" data-test-id="favourites-page-empty">
              You haven&apos;t starred any dashboards yet. Click the star icon on a dashboard card to add it here.
            </p>
          ) : (
            <div className="favourites_page_grid">
              {favouriteDashboards.map((dashboard) => (
                <DashboardCard key={dashboard.key} dashboard={dashboard} />
              ))}
            </div>
          )}
        </div>

        <ToastContainer
          position="top-right"
          autoClose={2500}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick={true}
          draggable={false}
          pauseOnHover={false}
        />
      </ErrorBoundary>
    </CedarShellLayout>
  );
};
